// validators/bigint.ts
import { assertSchema, assertValidation, ValidationError } from "../errors.mjs";
import { AbstractValidator, makeValidatorFactory } from "../types.mjs";
var AnyBigIntValidator = class extends AbstractValidator {
  validate(value) {
    if (typeof value === "number") {
      try {
        value = BigInt(value);
      } catch {
        throw new ValidationError("BigInt can not be parsed from number");
      }
    }
    assertValidation(typeof value === "bigint", 'Value is not a "bigint"');
    return value;
  }
};
var BigIntValidator = class extends AbstractValidator {
  fromString;
  fromNumber;
  exclusiveMaximum;
  exclusiveMinimum;
  maximum;
  minimum;
  multipleOf;
  brand;
  constructor(constraints = {}) {
    super();
    const {
      exclusiveMaximum,
      exclusiveMinimum,
      maximum,
      minimum,
      multipleOf,
      fromString = false,
      fromNumber = true
    } = constraints;
    if ("brand" in constraints) this.brand = constraints.brand;
    this.fromString = fromString;
    this.fromNumber = fromNumber;
    const _exclusiveMaximum = exclusiveMaximum === void 0 ? void 0 : BigInt(exclusiveMaximum);
    const _exclusiveMinimum = exclusiveMinimum === void 0 ? void 0 : BigInt(exclusiveMinimum);
    const _maximum = maximum === void 0 ? void 0 : BigInt(maximum);
    const _minimum = minimum === void 0 ? void 0 : BigInt(minimum);
    const _multipleOf = multipleOf === void 0 ? void 0 : BigInt(multipleOf);
    if (_maximum !== void 0 && _minimum !== void 0) {
      assertSchema(_maximum >= _minimum, `Constraint "minimum" (${_minimum}) is greater than "maximum" (${_maximum})`);
    }
    if (_exclusiveMaximum !== void 0 && _minimum !== void 0) {
      assertSchema(
        _exclusiveMaximum > _minimum,
        `Constraint "exclusiveMaximum" (${_exclusiveMaximum}) must be greater than "minimum" (${_minimum})`
      );
    }
    if (_exclusiveMinimum !== void 0 && _maximum != void 0) {
      assertSchema(
        _maximum > _exclusiveMinimum,
        `Constraint "maximum" (${_maximum}) must be greater than "exclusiveMinimum" (${_exclusiveMinimum})`
      );
    }
    if (_exclusiveMinimum != void 0 && _exclusiveMaximum !== void 0) {
      assertSchema(
        _exclusiveMaximum > _exclusiveMinimum,
        `Constraint "exclusiveMaximum" (${_exclusiveMaximum}) must be greater than "exclusiveMinimum" (${_exclusiveMinimum})`
      );
    }
    if (_multipleOf !== void 0) {
      assertSchema(_multipleOf > 0, `Constraint "multipleOf" (${_multipleOf}) must be greater than zero`);
    }
    this.exclusiveMaximum = _exclusiveMaximum;
    this.exclusiveMinimum = _exclusiveMinimum;
    this.maximum = _maximum;
    this.minimum = _minimum;
    this.multipleOf = _multipleOf;
  }
  validate(value) {
    if (typeof value === "string" && this.fromString || typeof value === "number" && this.fromNumber) {
      try {
        value = BigInt(value);
      } catch {
        throw new ValidationError("BigInt can not be parsed from " + typeof value);
      }
    }
    assertValidation(typeof value === "bigint", 'Value is not a "bigint"');
    assertValidation(
      this.minimum === void 0 || value >= this.minimum,
      `BigInt is less than ${this.minimum}`
    );
    assertValidation(
      this.maximum === void 0 || value <= this.maximum,
      `BigInt is greater than ${this.maximum}`
    );
    assertValidation(
      this.exclusiveMinimum === void 0 || value > this.exclusiveMinimum,
      `BigInt is less than or equal to ${this.exclusiveMinimum}`
    );
    assertValidation(
      this.exclusiveMaximum === void 0 || value < this.exclusiveMaximum,
      `BigInt is greater than or equal to ${this.exclusiveMaximum}`
    );
    assertValidation(
      this.multipleOf === void 0 || !(value % this.multipleOf),
      `BigInt is not a multiple of ${this.multipleOf}`
    );
    return value;
  }
};
function bigintValidatorFactory(constraints) {
  return new BigIntValidator(constraints);
}
var bigint = makeValidatorFactory(new AnyBigIntValidator(), bigintValidatorFactory);
export {
  AnyBigIntValidator,
  BigIntValidator,
  bigint,
  bigintValidatorFactory
};
//# sourceMappingURL=bigint.mjs.map
